'use client'

/* eslint-disable react-you-might-not-need-an-effect/no-initialize-state */
import { PropsWithChildren, useEffect, useState } from 'react'

const NoSSR = ({ children }: PropsWithChildren) => {
    const [mounted, setMounted] = useState(false)
    useEffect(() => {
        setMounted(true)
    }, [])

    if (!mounted)
        return null

    return children
}

export default NoSSR
